import fetchPartners from './getPartners';

const watchPartners = [fetchPartners];

export default watchPartners;
